import { shopPrefix } from '../../config';
import { http } from '../axios';

export const addProductsToGroupByIsbns = (productGroupId: string, body: { isbns: string }) => {
    return http
        .post<void>(`${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/bulk/isbns/add`, body, {
            pathParams: { productGroupId }
        })
        .then(res => res.data);
};
